import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/reducers';

const CartCountBadge = (): JSX.Element => {
  let cartItemCount = useSelector((state: RootState) => state.cart.current.item_count);
  
  // find out how many gifts are in the cart 
  if (window['freeCartGifts']) {
    const cartItems = useSelector((state: RootState) => state.cart.current.items);
    for (let i = 0; i < cartItems.length; i++) {
      const cartItem = cartItems[i];
      for (let j = 0; j < window['freeCartGifts'].length; j++) {
        const giftitem = window['freeCartGifts'][j];
        if (cartItem.variant_id === giftitem.id) {
          // subtract from cartItemCount
          cartItemCount = cartItemCount - cartItem.quantity;
        }
      }
    }
  }

  return <div className="cart-count-badge">{cartItemCount}</div>
};

export default CartCountBadge

